module.exports = __webpack_public_path__ + "assets/certificate_pdf/Disaster Risk Montioring UsingSatellite Imagery_1120128.18b4e954.pdf";